import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonCommonModule } from '../../common/components/common.module';
import { BreadCrumbComponent } from './breadcrumb/bread-crumb.component';
import { SeparatorComponent } from './separator/separator.component';
import { BreadCrumbBaseComponent } from './bread-crumb-base/bread-crumb-base.component';

@NgModule({
  declarations: [BreadCrumbComponent, SeparatorComponent, BreadCrumbBaseComponent],
  imports: [CommonModule, SkeletonCommonModule],
  exports: [BreadCrumbComponent]
})
export class BreadcrumbModule {}
